<template>
    <div class="" data-testid="workflow-edit-details">
        <div class="workflow-edit-details">
            <!-- Profit & Loss Card -->
            <v-card outlined class="">
                <v-card-title class="d-flex justify-space-between py-2 px-2 card-title">
                    <v-checkbox
                        dense
                        hide-details
                        label="Profit & Loss"
                        class="ma-0 pt-0"
                        v-model="selectAllPl"
                        data-testid="workflow-edit-details__pl-select-all"
                    ></v-checkbox>
                </v-card-title>
                <v-divider />
                <div class="pa-4 d-flex gap-3">
                    <div class="w-50">
                        <div class="" data-testid="workflow-edit-details__proforma-heading">
                            {{
                            $nova.labelsName(
                                "my_reporting_units_page",
                                "proforma_shortform_label",
                                "Proforma"
                            )
                            }}
                        </div>
                        <v-divider class="my-3"></v-divider>
                        <div class="" data-testid="workflow-edit-details__proforma-local-controls">
                            <v-checkbox
                            dense
                            hide-details
                            :label="
                                $nova.labelsName(
                                'my_reporting_units_page',
                                'commentary_local_key_label',
                                'Local'
                                ) + ' Control'
                            "
                            v-model="workflowData.localcontrol_proforma"
                            data-testid="workflow-edit-details__localcontrol-proforma-checkbox"
                            ></v-checkbox>
                            <v-checkbox
                            dense
                            class=""
                            hide-details
                            :label="
                                $nova.labelsName(
                                'my_reporting_units_page',
                                'commentary_local_key_label',
                                'Local'
                                ) + ' Management'
                            "
                            v-model="workflowData.localmanagement_proforma"
                            data-testid="workflow-edit-details__localmanagement-proforma-checkbox"
                            ></v-checkbox>
                        </div>
                        <div class="" data-testid="workflow-edit-details__proforma-regional-controls">
                            <v-checkbox
                            dense
                            hide-details
                            :label="
                                $nova.labelsName(
                                'my_reporting_units_page',
                                'commentary_regional_key_label',
                                'Regional'
                                ) + ' Control'
                            "
                            v-model="workflowData.regionalcontrol_proforma"
                            data-testid="workflow-edit-details__regionalcontrol-proforma-checkbox"
                            ></v-checkbox>
                            <v-checkbox
                            dense
                            class=""
                            hide-details
                            :label="
                                $nova.labelsName(
                                'my_reporting_units_page',
                                'commentary_regional_key_label',
                                'Regional'
                                ) + ' Management'
                            "
                            v-model="workflowData.regionalmanagement_proforma"
                            data-testid="workflow-edit-details__regionalmanagement-proforma-checkbox"
                            ></v-checkbox>
                        </div>
                    </div>
                    <v-divider vertical />
                    <div class="w-50">
                         <div class="" data-testid="workflow-edit-details__forecast-heading">
                            {{
                            $nova.labelsName(
                                "my_reporting_units_page",
                                "forecast_shortform_label",
                                "Forecast"
                            )
                            }}
                        </div>
                        <v-divider class="my-3"></v-divider>
                        <div class="" data-testid="workflow-edit-details__forecast-local-controls">
                            <v-checkbox
                            dense
                            hide-details
                            :label="
                                $nova.labelsName(
                                'my_reporting_units_page',
                                'commentary_local_key_label',
                                'Local'
                                ) + ' Control'
                            "
                            v-model="workflowData.localcontrol_forecast"
                            data-testid="workflow-edit-details__localcontrol-forecast-checkbox"
                            ></v-checkbox>
                            <v-checkbox
                            dense
                            class=""
                            hide-details
                            :label="
                                $nova.labelsName(
                                'my_reporting_units_page',
                                'commentary_local_key_label',
                                'Local'
                                ) + ' Management'
                            "
                            v-model="workflowData.localmanagement_forecast"
                            data-testid="workflow-edit-details__localmanagement-forecast-checkbox"
                            ></v-checkbox>
                        </div>
                        <div class="" data-testid="workflow-edit-details__forecast-regional-controls">
                            <v-checkbox
                            dense
                            hide-details
                            :label="
                                $nova.labelsName(
                                'my_reporting_units_page',
                                'commentary_regional_key_label',
                                'Regional'
                                ) + ' Control'
                            "
                            v-model="workflowData.regionalcontrol_forecast"
                            data-testid="workflow-edit-details__regionalcontrol-forecast-checkbox"
                            ></v-checkbox>
                            <v-checkbox
                            dense
                            class=""
                            hide-details
                            :label="
                                $nova.labelsName(
                                'my_reporting_units_page',
                                'commentary_regional_key_label',
                                'Regional'
                                ) + ' Management'
                            "
                            v-model="workflowData.regionalmanagement_forecast"
                            data-testid="workflow-edit-details__regionalmanagement-forecast-checkbox"
                            ></v-checkbox>
                        </div>
                    </div>
                </div>
            </v-card>

            <!-- Balance Sheet Card -->
            <v-card outlined class="">
                <v-card-title class="d-flex justify-space-between py-2 px-2 card-title">
                    <v-checkbox
                        dense
                        hide-details
                        label="Balance Sheet"
                        class="ma-0 pt-0"
                        v-model="selectAllBs"
                        data-testid="workflow-edit-details__bs-select-all"
                    ></v-checkbox>
                </v-card-title>
                <v-divider></v-divider>
                <div class="pa-4 d-flex gap-3">
                    <div class="w-50">
                        <div class="" data-testid="workflow-edit-details__bs-proforma-heading">
                            {{
                           $nova.labelsName('my_reporting_units_page', 'proforma_shortform_label_balancesheet', 'Proforma')
                            }}
                        </div>
                        <v-divider class="my-3"></v-divider>
                        <div class="" data-testid="workflow-edit-details__bs-proforma-local-controls">
                            <v-checkbox
                            dense
                            hide-details
                            :label="
                                $nova.labelsName(
                                'my_reporting_units_page',
                                'commentary_local_key_label',
                                'Local'
                                ) + ' Control'
                            "
                            v-model="workflowData.localcontrol_proforma_bs"
                            data-testid="workflow-edit-details__localcontrol-proforma-bs-checkbox"
                            ></v-checkbox>
                            <v-checkbox
                            dense
                            class=""
                            hide-details
                            :label="
                                $nova.labelsName(
                                'my_reporting_units_page',
                                'commentary_local_key_label',
                                'Local'
                                ) + ' Management'
                            "
                            v-model="workflowData.localmanagement_proforma_bs"
                            data-testid="workflow-edit-details__localmanagement-proforma-bs-checkbox"
                            ></v-checkbox>
                        </div>
                        <div class="" data-testid="workflow-edit-details__bs-proforma-regional-controls">
                            <v-checkbox
                            dense
                            hide-details
                            :label="
                                $nova.labelsName(
                                'my_reporting_units_page',
                                'commentary_regional_key_label',
                                'Regional'
                                ) + ' Control'
                            "
                            v-model="workflowData.regionalcontrol_proforma_bs"
                            data-testid="workflow-edit-details__regionalcontrol-proforma-bs-checkbox"
                            ></v-checkbox>
                            <v-checkbox
                            dense
                            class=""
                            hide-details
                            :label="
                                $nova.labelsName(
                                'my_reporting_units_page',
                                'commentary_regional_key_label',
                                'Regional'
                                ) + ' Management'
                            "
                            v-model="workflowData.regionalmanagement_proforma_bs"
                            data-testid="workflow-edit-details__regionalmanagement-proforma-bs-checkbox"
                            ></v-checkbox>
                        </div>
                    </div>
                    <v-divider vertical />
                    <div class="w-50">
                        <div class="" data-testid="workflow-edit-details__bs-forecast-heading">
                            {{ $nova.labelsName("my_reporting_units_page","forecast_shortform_label_balancesheet","Forecast")  }}
                        </div>
                        <v-divider class="my-3"></v-divider>
                        <div class="" data-testid="workflow-edit-details__bs-forecast-local-controls">
                            <v-checkbox
                            dense
                            hide-details
                            :label="
                                $nova.labelsName(
                                'my_reporting_units_page',
                                'commentary_local_key_label',
                                'Local'
                                ) + ' Control'
                            "
                            v-model="workflowData.localcontrol_forecast_bs"
                            data-testid="workflow-edit-details__localcontrol-forecast-bs-checkbox"
                            ></v-checkbox>
                            <v-checkbox
                            dense
                            class=""
                            hide-details
                            :label="
                                $nova.labelsName(
                                'my_reporting_units_page',
                                'commentary_local_key_label',
                                'Local'
                                ) + ' Management'
                            "
                            v-model="workflowData.localmanagement_forecast_bs"
                            data-testid="workflow-edit-details__localmanagement-forecast-bs-checkbox"
                            ></v-checkbox>
                        </div>
                        <div class="" data-testid="workflow-edit-details__bs-forecast-regional-controls">
                            <v-checkbox
                            dense
                            hide-details
                            :label="
                                $nova.labelsName(
                                'my_reporting_units_page',
                                'commentary_regional_key_label',
                                'Regional'
                                ) + ' Control'
                            "
                            v-model="workflowData.regionalcontrol_forecast_bs"
                            data-testid="workflow-edit-details__regionalcontrol-forecast-bs-checkbox"
                            ></v-checkbox>
                            <v-checkbox
                            dense
                            class=""
                            hide-details
                            :label="
                                $nova.labelsName(
                                'my_reporting_units_page',
                                'commentary_regional_key_label',
                                'Regional'
                                ) + ' Management'
                            "
                            v-model="workflowData.regionalmanagement_forecast_bs"
                            data-testid="workflow-edit-details__regionalmanagement-forecast-bs-checkbox"
                            ></v-checkbox>
                        </div>
                    </div>
                </div>
            </v-card>

            <!-- Others Card -->
            <v-card outlined class="">
                <v-card-title class="d-flex justify-space-between py-2 px-2 card-title">
                    <v-checkbox
                        dense
                        hide-details
                        :label="$nova.labelsName('my_reporting_units_page', 'commentary_others_key_label', 'Others')"
                        class="ma-0 pt-0"
                        v-model="selectAllOthers"
                        data-testid="workflow-edit-details__others-select-all"
                    ></v-checkbox>
                </v-card-title>
                <v-divider></v-divider>
                <div class="pa-4">
                    <!-- Bulk Approve Control -->
                    <div class="mb-2" data-testid="workflow-edit-details__bulk-approve-section">
                        <v-checkbox
                            dense
                            hide-details
                            label="Bulk approve"
                            v-model="otherSettingsData.bulkapprove_control"
                            :disabled="!isAnyControlWorkflowEnabled"
                            data-testid="workflow-edit-details__bulkapprove-control-checkbox"
                        >
                        </v-checkbox>
                        <div
                            class="error--text text-caption mt-1"
                            v-if="!isAnyControlWorkflowEnabled"
                            data-testid="workflow-edit-details__bulk-approve-disabled-message"
                        >
                        </div>
                    </div>

                    <!-- SOD -->
                    <div class="mb-2" data-testid="workflow-edit-details__sod-section">
                        <v-checkbox
                            dense
                            hide-details
                            label="Segregation of Duties"
                            v-model="otherSettingsData.sodEnabled"
                            data-testid="workflow-edit-details__sod-enabled-checkbox"
                        >
                        </v-checkbox>
                    </div>

                    <!-- Auto Submission -->
                    <div class="mb-2" data-testid="workflow-edit-details__auto-submission-section">
                        <v-checkbox
                            dense
                            hide-details
                            label="Regional Level auto submission"
                            v-model="otherSettingsData.autoSubmissionEnabled"
                            data-testid="workflow-edit-details__auto-submission-enabled-checkbox"
                        >
                        </v-checkbox>
                    </div>
                </div>
            </v-card>
        </div>
        <v-divider class="mt-4" />
        <div class="d-flex justify-end mt-4">
            <v-btn color="primary" @click="updateWorkflowSettings" :loading="loading" data-testid="workflow-edit-details__update-button">Update</v-btn>
        </div>
    </div>
</template>

<script>
import { UPDATE_RU_SETTINGS } from '../../../utils/constants';

const WORKFLOW_FIELD_KEYS = [
    'localcontrol_proforma',
    'localmanagement_proforma',
    'regionalcontrol_proforma',
    'regionalmanagement_proforma',
    'localcontrol_forecast',
    'localmanagement_forecast',
    'regionalcontrol_forecast',
    'regionalmanagement_forecast',
    'localcontrol_proforma_bs',
    'localmanagement_proforma_bs',
    'regionalcontrol_proforma_bs',
    'regionalmanagement_proforma_bs',
    'localcontrol_forecast_bs',
    'localmanagement_forecast_bs',
    'regionalcontrol_forecast_bs',
    'regionalmanagement_forecast_bs',
];

export default {
    name: 'WorkflowConfigTab',
    props: {
        detail: {
            type: Object,
            required: true,
            default: () => ({})
        },
        isBulkMode: {
            type: Boolean,
            default: false
        },
        selectedIds: {
            type: Array,
            default: () => []
        },
        selectedDetails: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            loading: false,
            workflowData: {
                // Profit & Loss (Default keys)
                localcontrol_proforma: false,
                localmanagement_proforma: false,
                regionalcontrol_proforma: false,
                regionalmanagement_proforma: false,
                localcontrol_forecast: false,
                localmanagement_forecast: false,
                regionalcontrol_forecast: false,
                regionalmanagement_forecast: false,

                // Balance Sheet (New keys with _bs suffix)
                localcontrol_proforma_bs: false,
                localmanagement_proforma_bs: false,
                regionalcontrol_proforma_bs: false,
                regionalmanagement_proforma_bs: false,
                localcontrol_forecast_bs: false,
                localmanagement_forecast_bs: false,
                regionalcontrol_forecast_bs: false,
                regionalmanagement_forecast_bs: false,
            },
            otherSettingsData: {
                bulkapprove_control: false,
                sodEnabled: false,
                autoSubmissionEnabled: false,
            },
            
            // To track changes
            initialWorkflowData: {},
            initialOtherSettings: {},
        };
    },
    computed: {
        isAnyControlWorkflowEnabled() {
            return (
                this.workflowData.localcontrol_proforma ||
                this.workflowData.localcontrol_forecast ||
                this.workflowData.regionalcontrol_proforma ||
                this.workflowData.regionalcontrol_forecast ||
                this.workflowData.localcontrol_proforma_bs ||
                this.workflowData.localcontrol_forecast_bs ||
                this.workflowData.regionalcontrol_proforma_bs ||
                this.workflowData.regionalcontrol_forecast_bs
            );
        },
        selectAllPl: {
            get() {
                const keys = [
                    'localcontrol_proforma', 'localmanagement_proforma', 'regionalcontrol_proforma', 'regionalmanagement_proforma',
                    'localcontrol_forecast', 'localmanagement_forecast', 'regionalcontrol_forecast', 'regionalmanagement_forecast'
                ];
                return keys.every(key => this.workflowData[key]);
            },
            set(val) {
                const keys = [
                    'localcontrol_proforma', 'localmanagement_proforma', 'regionalcontrol_proforma', 'regionalmanagement_proforma',
                    'localcontrol_forecast', 'localmanagement_forecast', 'regionalcontrol_forecast', 'regionalmanagement_forecast'
                ];
                keys.forEach(key => this.workflowData[key] = val);
            }
        },
        selectAllBs: {
            get() {
                const keys = [
                    'localcontrol_proforma_bs', 'localmanagement_proforma_bs', 'regionalcontrol_proforma_bs', 'regionalmanagement_proforma_bs',
                    'localcontrol_forecast_bs', 'localmanagement_forecast_bs', 'regionalcontrol_forecast_bs', 'regionalmanagement_forecast_bs'
                ];
                return keys.every(key => this.workflowData[key]);
            },
            set(val) {
                const keys = [
                    'localcontrol_proforma_bs', 'localmanagement_proforma_bs', 'regionalcontrol_proforma_bs', 'regionalmanagement_proforma_bs',
                    'localcontrol_forecast_bs', 'localmanagement_forecast_bs', 'regionalcontrol_forecast_bs', 'regionalmanagement_forecast_bs'
                ];
                keys.forEach(key => this.workflowData[key] = val);
            }
        },
        selectAllOthers: {
            get() {
                return (
                    this.otherSettingsData.bulkapprove_control &&
                    this.otherSettingsData.sodEnabled &&
                    this.otherSettingsData.autoSubmissionEnabled
                );
            },
            set(val) {
                if (this.isAnyControlWorkflowEnabled || !val) {
                     this.otherSettingsData.bulkapprove_control = val;
                }
                this.otherSettingsData.sodEnabled = val;
                this.otherSettingsData.autoSubmissionEnabled = val;
            }
        }
    },
    watch: {
        detail: {
             handler(val) {
                if (val && val.code) {
                    this.initializeWorkflowData();
                }
            },
            deep: true,
            immediate: true
        },
        isAnyControlWorkflowEnabled(newVal) {
            // Auto-disable bulk approve if no control workflows are enabled
            if (!newVal) {
                this.otherSettingsData.bulkapprove_control = false;
            }
        },
    },
    methods: {
        initializeWorkflowData() {
            if (!this.detail) return;

            const workflowValue = (key) => {
                if (key.endsWith('_bs')) {
                    const baseKey = key.replace('_bs', '');
                    return this.normalizeBoolean(this.detail[key] ?? this.detail[baseKey], false);
                }
                return this.normalizeBoolean(this.detail[key], false);
            };

            this.workflowData = {
                // PL
                localcontrol_proforma: workflowValue('localcontrol_proforma'),
                localmanagement_proforma: workflowValue('localmanagement_proforma'),
                regionalcontrol_proforma: workflowValue('regionalcontrol_proforma'),
                regionalmanagement_proforma: workflowValue('regionalmanagement_proforma'),
                localcontrol_forecast: workflowValue('localcontrol_forecast'),
                localmanagement_forecast: workflowValue('localmanagement_forecast'),
                regionalcontrol_forecast: workflowValue('regionalcontrol_forecast'),
                regionalmanagement_forecast: workflowValue('regionalmanagement_forecast'),

                // BS
                localcontrol_proforma_bs: workflowValue('localcontrol_proforma_bs'),
                localmanagement_proforma_bs: workflowValue('localmanagement_proforma_bs'),
                regionalcontrol_proforma_bs: workflowValue('regionalcontrol_proforma_bs'),
                regionalmanagement_proforma_bs: workflowValue('regionalmanagement_proforma_bs'),
                localcontrol_forecast_bs: workflowValue('localcontrol_forecast_bs'),
                localmanagement_forecast_bs: workflowValue('localmanagement_forecast_bs'),
                regionalcontrol_forecast_bs: workflowValue('regionalcontrol_forecast_bs'),
                regionalmanagement_forecast_bs: workflowValue('regionalmanagement_forecast_bs'),
            };

            this.otherSettingsData = {
                bulkapprove_control: this.normalizeBoolean(this.detail.bulkapprove_control, false),
                sodEnabled: this.getSodValue(this.detail),
                autoSubmissionEnabled: this.normalizeBoolean(this.detail.auto_regional_commentary_submission_enabled, false),
            };

            // Store initial state for change detection
            this.initialWorkflowData = JSON.parse(JSON.stringify(this.workflowData));
            this.initialOtherSettings = JSON.parse(JSON.stringify(this.otherSettingsData));
        },

        hasWorkflowDataChanged() {
            if (this.isBulkMode && this.selectedDetails.length > 0) {
                return this.selectedDetails.some(detail =>
                    WORKFLOW_FIELD_KEYS.some(
                        key => this.getWorkflowFieldValue(detail, key) !== !!this.workflowData[key]
                    )
                );
            }

            return JSON.stringify(this.workflowData) !== JSON.stringify(this.initialWorkflowData);
        },
        
        hasBulkApproveChanged() {
            if (this.isBulkMode && this.selectedDetails.length > 0) {
                const targetBulkApprove = !!this.otherSettingsData.bulkapprove_control;
                return this.selectedDetails.some(
                    detail => this.normalizeBoolean(detail?.bulkapprove_control, false) !== targetBulkApprove
                );
            }

            return this.otherSettingsData.bulkapprove_control !== this.initialOtherSettings.bulkapprove_control;
        },

        normalizeBoolean(value, defaultValue = false) {
            if (value == null) return defaultValue;
            if (typeof value === 'boolean') return value;
            if (typeof value === 'string') {
                const normalized = value.trim().toLowerCase();
                if (['yes', 'true', '1', 'y'].includes(normalized)) return true;
                if (['no', 'false', '0', 'n'].includes(normalized)) return false;
            }
            return !!value;
        },

        getWorkflowFieldValue(detail, key) {
            if (!detail) return false;

            if (key.endsWith('_bs')) {
                const baseKey = key.replace('_bs', '');
                return this.normalizeBoolean(detail[key] ?? detail[baseKey], false);
            }

            return this.normalizeBoolean(detail[key], false);
        },

        getSodValue(detail) {
            if (!detail) return true;

            const rawValue = detail.sodEnabled != null ? detail.sodEnabled : detail.sod_enabled;
            if (rawValue == null) return true;

            return this.normalizeBoolean(rawValue, true);
        },

        hasSodChanged() {
            const targetSod = !!this.otherSettingsData.sodEnabled;

            if (this.isBulkMode && this.selectedDetails.length > 0) {
                return this.selectedDetails.some(
                    detail => this.getSodValue(detail) !== targetSod
                );
            }

            return !!this.otherSettingsData.sodEnabled !== !!this.initialOtherSettings.sodEnabled;
        },

        hasAutoSubmissionChanged() {
            const targetAutoSubmission = !!this.otherSettingsData.autoSubmissionEnabled;

            if (this.isBulkMode && this.selectedDetails.length > 0) {
                return this.selectedDetails.some(
                    detail => this.normalizeBoolean(detail?.auto_regional_commentary_submission_enabled, false) !== targetAutoSubmission
                );
            }

            return targetAutoSubmission !== !!this.initialOtherSettings.autoSubmissionEnabled;
        },

        syncInitialStateFromForm() {
            this.initialWorkflowData = JSON.parse(JSON.stringify(this.workflowData));
            this.initialOtherSettings = JSON.parse(JSON.stringify(this.otherSettingsData));
        },

        async updateWorkflowSettings() {
            this.loading = true;
            try {
                const targetIds = this.isBulkMode ? this.selectedIds : [this.detail._id];

                // Detect Changes
                const workflowChanged = this.hasWorkflowDataChanged();
                const bulkApproveChanged = this.hasBulkApproveChanged();
                const sodChanged = this.hasSodChanged();
                const autoSubChanged = this.hasAutoSubmissionChanged();

                if (this.isBulkMode) {
                    const promises = [];

                    // 1. Bulk Workflow Settings (Uses ENABLE_DISABLE_BULK)
                    // This endpoint likely handles Workflow Data + SOD + Auto Submission in one go
                    if (workflowChanged || sodChanged || autoSubChanged) {
                         promises.push(this.$store.dispatch(
                            `varianceanalysis/reportingUnit/${UPDATE_RU_SETTINGS.DISPATCHERS.UPDATE_BULK_WORKFLOW}`,
                            {
                                reportingUnitIds: targetIds,
                                workflowData: this.workflowData,
                                otherSettingsData: this.otherSettingsData,
                                axiosInstance: this.axios,
                                showNotification: false,
                            }
                        ));
                    }
                    
                    // 2. Bulk Approve (Uses ENABLE_DISABLE_BULK_APPROVE)
                    // This endpoint is separate, so we call it if changed
                    if (bulkApproveChanged) {
                        promises.push(this.$store.dispatch(
                            `varianceanalysis/reportingUnit/${UPDATE_RU_SETTINGS.DISPATCHERS.UPDATE_BULK_APPROVE}`,
                            {
                                reportingUnitIds: targetIds,
                                bulkapprove_control: this.otherSettingsData.bulkapprove_control,
                                // workflowData: this.workflowData, // Not needed for this specific call usually
                                // otherSettingsData: this.otherSettingsData, // Not needed
                                axiosInstance: this.axios,
                                showNotification: false,
                            }
                        ));
                    }

                    if (promises.length > 0) {
                        await Promise.all(promises);
                        this.syncInitialStateFromForm();
                    } else {
                        this.$store.commit("sbSuccess", "No changes detected to update.");
                        this.loading = false;
                        return;
                    }

                } else {
                    // Single Mode: Use existing individual APIs based on changes
                    const chunkSize = 5; 
                    for (let i = 0; i < targetIds.length; i += chunkSize) {
                        const chunk = targetIds.slice(i, i + chunkSize);
                        const promises = [];

                        chunk.forEach(id => {
                            // 1. Workflow Settings
                            if (workflowChanged) {
                                promises.push(this.$store.dispatch(
                                    UPDATE_RU_SETTINGS.DISPATCHERS.UPDATE_REPORTING_UNIT_WORKFLOW_SETTINGS,
                                    {
                                        reportingUnitId: id,
                                        workflowData: this.workflowData,
                                        axiosInstance: this.axios,
                                        showNotification: false,
                                    }
                                ));
                            }

                            // 2. Bulk Approve
                            if (bulkApproveChanged && this.isAnyControlWorkflowEnabled) {
                                promises.push(this.$store.dispatch(
                                    `varianceanalysis/reportingUnit/${UPDATE_RU_SETTINGS.DISPATCHERS.UPDATE_BULK_APPROVE}`,
                                    {
                                        reportingUnitId: id,
                                        bulkapprove_control: this.otherSettingsData.bulkapprove_control,
                                        axiosInstance: this.axios,
                                        showNotification: false,
                                    }
                                ));
                            }

                            // 3. Auto Submission
                            if (autoSubChanged) {
                                promises.push(this.$store.dispatch(
                                    `varianceanalysis/reportingUnit/${UPDATE_RU_SETTINGS.DISPATCHERS.UPDATE_AUTO_SUBMISSION}`,
                                    {
                                        reportingUnitId: id,
                                        auto_regional_commentary_submission_enabled: this.otherSettingsData.autoSubmissionEnabled,
                                        axiosInstance: this.axios,
                                        showNotification: false,
                                    }
                                ));
                            }

                            // 4. SOD Status
                            if (sodChanged) {
                                promises.push(this.$store.dispatch(
                                    `varianceanalysis/reportingUnit/${UPDATE_RU_SETTINGS.DISPATCHERS.UPDATE_SOD_STATUS}`,
                                    {
                                        reportingUnitId: id,
                                        sod_status: !!this.otherSettingsData.sodEnabled,
                                        axiosInstance: this.axios,
                                        showNotification: false,
                                    }
                                ));
                            }
                        });

                        if (promises.length > 0) {
                             await Promise.all(promises);
                        } else {
                             // No changes
                             // We can break early or just show notification at end
                        }
                    }
                    
                    if (!workflowChanged && !bulkApproveChanged && !sodChanged && !autoSubChanged) {
                         this.$store.commit("sbSuccess", "No changes detected to update.");
                         this.loading = false;
                         return;
                    }

                    this.syncInitialStateFromForm();
                }

                this.$store.commit("sbSuccess", "Settings updated successfully");
                this.$emit('refresh');
            } catch (error) {
                console.error(error);
                this.$store.commit("sbError", error.message || "Failed to update settings");
            } finally {
                this.loading = false;
            }
        },
    }
};
</script>
<style>
.workflow-edit-details {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 12px;
    grid-row-gap: 12px;
}
.card-title {
    background-color: var(--grey-75);
}
.card-title label{
    font-weight: 600;
    color: var(--grey-900) !important;
}
.w-50{
    width: 50%;
}
</style>